import React from 'react'
import { FaArrowRight, FaStar } from 'react-icons/fa'
function PY_Review_Program_Page() {
  return (
    <div>
    <div>
      <div className='container'>
      <div className='row d-sm-block d-md-none'>
            <div className='col-md-1'></div>
            <div className='col-md-10'>
            <div className='text-center review_component_text'>
                <h1 className='display-5 pb-2'>Testmonial</h1>
                <p className='fs-6'>Listen to the people who have made it! Explore the testimonies of former students who attested to the life-altering effects of their educational experiences.</p>
            </div>
            </div>
            <div className='col-md-1'></div>
        </div>
        <div className='row'>
            <div className='col-md-4 pt-5'>
                <div className='Program_review_comp'>
                    <div className='mt-5 px-5 review_component_text'>
                        <h1 className='pt-5 display-6'>Hear What Our Students Says</h1>
                        <p className='pt-4 fs-5'>25K+ Students have already learned with InternsElite</p>
                    </div>
                </div>
            </div>
            <div className='col-md-8'>
                <div className='row'>
                <div class="col-md-5 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Muskaan Prajapati</h5>
                    <h6 class="font-weight-bold my-2">Shyama Prasad Mukherji College for Women, Delhi University, Economics Honours</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    </ul>
                    <p class="">
                    <i class="fas fa-quote-left pe-2"></i>This program of Traineeship and Internship provided by the Internselite is much better. It was a good experience to learn and work in Internselite..  
                    </p>
                </div>
                </div>
                <div class="col-md-7 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Anshuman Maitra</h5>
                    <h6 class="font-weight-bold my-2">Govt. College of Engineering and Leather Technology, CSE</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    </ul>
                    <p class="">
                    <i class="fas fa-quote-left pe-2"></i>Coding is something that can't be done exclusively. We need community, team , mentors ... In this internship, I have gained such mentors as my teacher , Ayan sir to support freshers like me at any time to overcome our boundaries.... This is the embryonic stage of my journey as a AI/ML enthusiast which I have got to know from this internship.... Thank you InternsElite for giving me this opportunity..
                    </p>
                </div>
                </div>
                <div class="col-md-6 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Khushi Prajapati</h5>
                    <h6 class="font-weight-bold my-2">Shyama Prasad Mukherji College for Women, Delhi University</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar />
                    </li>
                    </ul>
                    <p class="mb-2">
                    <i class="fas fa-quote-left pe-2"></i>I am very much satisfied with the overall program from the training sessions, learnt a lot and it is able to build a strong base in my concept. Thankyou for such a wonderful traineeship program.
                    </p>
                </div>
                </div>
                <div class="col-md-6 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Nalamekala Sindhu</h5>
                    <h6 class="font-weight-bold my-2">Annamacharya Institute of Technology and Sciences,Tirupati, CSE</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    </ul>
                    <p class="">
                    <i class="fas fa-quote-left pe-2"></i>Internsellite's team demonstrated exceptional dedication, delivering high-quality results with professionalism and adaptability. Their impact on our project's success is commendable, making the collaboration a valuable experience.
                    </p>
                </div>
                </div>
                <div class="col-md-7 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Tohuto Sema</h5>
                    <h6 class="font-weight-bold my-2">Computer Science and Engineering -IIT Kharagpur</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar />
                    </li>
                    </ul>
                    <p class="">
                    <i class="fas fa-quote-left pe-2"></i>Hello, I'm Tohuto Sema. Internselite's Python course enlightened me on building models using libraries like scikit-learn and numpy. Despite wanting more hands-on tasks and finding the duration a bit lengthy, I gained valuable insights, and I'm grateful for the learning experience.
                    </p>
                </div>
                </div>
                <div class="col-md-5 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Aditya Mahadev Falle</h5>
                    <h6 class="font-weight-bold my-2">TKIET Warananagar, Mechanical Engineering</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar />
                    </li>
                    </ul>
                    <p class="">
                    <i class="fas fa-quote-left pe-2"></i>Grateful for the invaluable internship experience with Internselite. The supportive team and gained insights in Python have significantly contributed to my personal and professional growth. Excited about potential future collaborations with Internselite
                    </p>
                </div>
                </div>
                </div>
            </div>
        </div>
      </div>
    </div>
    </div>
  )
}

export default PY_Review_Program_Page
